var render = function render(){var _vm=this,_c=_vm._self._c;return _c('basicLayout',[(_vm.purchase_order.id)?_c('OrderLines',{attrs:{"purchase_order":_vm.purchase_order,"filter":"purchase_order","origin":"OrdersByPO","parent_can_supply_filter":"all"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }